// The table search field — a compact input that grows on focus.
//
// At rest it sits at `restWidth`; on focus it eases wider so there's room to
// read what you type. The magnifier gives a small scale pop, and its leading
// inset is tightened (DS cg-pl-3 → pl-2) so it sits closer to the border. Snaps
// under reduced motion. Debouncing (when the value keys an expensive query) is
// the caller's concern — this is just the field.
import { Input } from '@clickguard/design-system'
import { SearchLg } from './icons'

export const TableSearchInput = ({
	value,
	onChange,
	placeholder = 'Search',
	ariaLabel = 'Search the table',
	restWidth = 'w-[136px]',
	focusWidth = 'focus-within:w-[200px]'
}: {
	value: string
	onChange: (next: string) => void
	placeholder?: string
	ariaLabel?: string
	restWidth?: string
	focusWidth?: string
}) => (
	<div
		className={`group ${restWidth} transition-[width] duration-300 ease-out ${focusWidth} motion-reduce:transition-none [&>div>div]:!border-[rgb(var(--cg-border))] focus-within:[&>div>div]:!border-[rgb(var(--cg-brand))] [&>div>div>span]:!pl-2 [&_svg]:transition-transform [&_svg]:duration-300 [&:focus-within_svg]:scale-110 motion-reduce:[&_svg]:transition-none`}
	>
		<Input
			size="sm"
			state="default"
			placeholder={placeholder}
			value={value}
			onChange={(e) => onChange(e.target.value)}
			leadingIcon={<SearchLg className="h-4 w-4" />}
			aria-label={ariaLabel}
		/>
	</div>
)
